var map = {
	"./__tests__/questionnaires.test.js": [
		1369,
		782
	],
	"./act.js": [
		2623
	],
	"./caat.js": [
		6682
	],
	"./cat.js": [
		3879
	],
	"./copd-ps.js": [
		4379,
		911
	],
	"./monthly-check-in.js": [
		9799
	],
	"./r-scale.js": [
		3874
	],
	"./respHealthAssessment.js": [
		9809,
		135
	],
	"./sgrq.js": [
		4236
	],
	"./weekly-check-in.js": [
		8125
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8043;
module.exports = webpackAsyncContext;